import VueDraggableResizable from "draggable-resizable-vue3";

export default ({ app }) => {
  app.component("VueDraggableResizable", VueDraggableResizable);
};
